export default "__VITE_ASSET__e6093dd1__"